var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('b-card',[_c('div',[_c('div',{staticClass:"header-view"},[_c('figure',[_c('img',{attrs:{"src":_vm.logoSucursalURL,"alt":_vm.cargo?.sucursal?.nombre}})])]),_c('div',[_c('h3',[_vm._v("PERFIL Y FUNCIONES DE CARGO")]),_c('h4',[_vm._v("Talento Humano")])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }